module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/FrontDay/Kanagawa_FrontDay_MRI_RCP85_End.png";